import * as Coremetrics from '@component/common/src/util/Coremetrics';
// import * as TagManager from '@component/common/src/util/TagManagerUtil';

export default {
  createLinkClickTag(type) {
    let href = '?cm_sp=simplified_account-_-my_notifications_panel-_-';
    if (type === 'my_notifications') {
      href = '?cm_sp=macys_account-_-my_account-_-';
    }
    href += type;
    if (typeof cmMakeTag !== 'undefined') {
      Coremetrics.createLinkClickTag({
        href,
        name: `Notification ${type}`,
      });
    }
    // TODO: enable once adobe/tealium specs are final
    // let linkData;
    // if (type === 'my_notifications') {
    //   linkData = 'Notification Icon';
    // } else if (type === 'x') {
    //   linkData = 'Dismiss Notifications Panel';
    // } else {
    //   linkData = `Notification ${type}`;
    // }
    // TagManager.fireTag('link', linkData);
  },
};
